import moment from "moment";
import {
  Link,
  Paper,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

//Common Styles
import {
  CustomTableRowTR,
  StyledTable,
  TableData,
  TableHeader,
  TableTopHeader,
  TableWrapper,
  Title,
} from "../../styles/commonStyles";

//Componets
import CustomCallIconButton from "../Common/CallButton/CustomCallIconButton";

//Enums
import { UserType } from "../../enums/common";

const ChefForPartyAssignedCookList = ({ cookRecord, isAssignedCookMg }: { cookRecord: any; isAssignedCookMg: boolean }) => {
  return (
    <TableWrapper>
      <TableTopHeader>
        <Title>Cook Details</Title>
      </TableTopHeader>

      <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
        <StyledTable>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "rgba(232, 235, 237, 0.3) !important",
              }}
            >
              <TableHeader>Id</TableHeader>
              <TableHeader>Name</TableHeader>
              <TableHeader>Position</TableHeader>
              <TableHeader>Cook Type</TableHeader>
              <TableHeader>Phone Number</TableHeader>
              <TableHeader>Allocated At</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {cookRecord?.length > 0 ? (
              cookRecord.map((row: any) => (
                <CustomTableRowTR key={row?.details?.id}>
                  <TableData>
                    <Link href={`/#/Cooks/${row?.details?.cookId}/show`} target="_self">
                      {row?.details?.cookId}
                    </Link>
                  </TableData>
                  <TableData>{row?.details?.cookName}</TableData>
                  <TableData>{row?.type}</TableData>
                  <TableData>
                    {(row?.type === "MAIN_CHEF" ? isAssignedCookMg : row?.profile?.cookFullProfile?.isMgCook) ? "Mg Cook" : "Part-time"}
                  </TableData>
                  <TableData style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                     <CustomCallIconButton
                        color="#6C7C93"
                        size={18}
                        toPhoneNumber={row?.details?.cookPhone}
                        userType={UserType.COOK}
                        referenceId={row?.details?.chefForPartyId}
                        referenceModelName="CHEF_FOR_PARTY"
                      />
                    {row?.details?.cookPhone}
                    </TableData>
                  <TableData>
                    {row?.details?.vendorAllocatedAt
                      ? moment(row?.details?.vendorAllocatedAt).format(
                          "DD/MM/YYYY hh:mm A",
                        )
                      : "-"}
                  </TableData>
                </CustomTableRowTR>
              ))
            ) : (
              <TableRow>
                <TableHeader colSpan={4} align="center">
                  No data available
                </TableHeader>
              </TableRow>
            )}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </TableWrapper>
  );
};

export default ChefForPartyAssignedCookList;
